export default "__VITE_ASSET__BANopFkk__"